import React, { Suspense } from 'react';
import { IMatchStatisticsDetail } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const MatchStatisticsDetailWrapper = React.lazy(() => import('./match-statistics'));
export interface IDynamicMatchStatisticsDetailWrapper extends IComponentModel<IMatchStatisticsDetail> {
  live?: boolean;
  model: any;
}

const DynamicMatchStatisticsDetail = ({
  /* istanbul ignore next: default value on mandatory field */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  live = false,
}: IDynamicMatchStatisticsDetailWrapper) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <MatchStatisticsDetailWrapper
      initialModel={validateModel(model) as IMatchStatisticsDetail}
      query={validateModel(query)}
      live={live}
    />
  </Suspense>
);

DynamicMatchStatisticsDetail.defaultProps = {
  live: false,
};

export default DynamicMatchStatisticsDetail;
